import { MESSAGES, ROW_STATES, applyStatus, labelFor } from './documentUpload';

export const DOCUMENT_STATUS_CHANGED = 'DocumentStatusChanged';
export const RECONNECT_DELAYS_MS = [0, 2000, 5000, 10000, 20000, 30000];
export const POLL_INTERVAL_MS = 5000;

export const CONNECTION_STATES = {
    IDLE: 'idle',
    CONNECTING: 'connecting',
    CONNECTED: 'connected',
    RECONNECTING: 'reconnecting',
    DISCONNECTED: 'disconnected',
};

export function hasCheckingRows(rows) {
    return (rows || []).some((row) => row.state === ROW_STATES.CHECKING);
}

export function shouldPoll(active, connectionState) {
    return !!active && connectionState === CONNECTION_STATES.DISCONNECTED;
}

export function showsReconnecting(row, connectionState) {
    return !!row && row.state === ROW_STATES.CHECKING && connectionState === CONNECTION_STATES.RECONNECTING;
}

export function rowLabel(row, connectionState) {
    return showsReconnecting(row, connectionState) ? MESSAGES.reconnecting : labelFor(row);
}

export function hubAccessToken(storedToken) {
    if (typeof storedToken !== 'string') return '';
    return storedToken.replace(/^bearer\s+/i, '').trim();
}

export function refreshableDocumentIds(rows) {
    return (rows || [])
        .filter((row) => row.documentDomainId && row.state !== ROW_STATES.UPLOADING)
        .map((row) => row.documentDomainId);
}

export function applyUpdate(rows, update) {
    if (!Array.isArray(rows) || !update || !update.documentDomainId || !update.status) return rows;
    let changed = false;
    const next = rows.map((row) => {
        if (row.documentDomainId !== update.documentDomainId) return row;
        if (row.state === ROW_STATES.UPLOADING && update.status === 'awaitingUpload') return row;
        const updated = applyStatus(row, update);
        if (updated !== row) changed = true;
        return updated;
    });
    return changed ? next : rows;
}
